import { Container } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

/** Tagging Page */
export const StyledTaggingContainer = styled(Container)`
  font-size: 1.6rem;
`;

export const StyledTabContent = styled.div`
  width: 100%;
  padding: 20px 0 20px 0;
`;

/** Tags Tab */

export const StyledTagsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;

export const StyledTagFilters = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 70%;
`;

export const StyledTagHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledTagActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

/** Tag Categories Tab */

export const StyledAddTagCategory = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 1rem;
`;

export const StyledTagCategoryHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  h6 {
    margin-bottom: 0;
  }
`;

export const StyledSubCategoriesContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const StyledScopesSelector = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  max-width: 44rem;
`;

export const StyledInfoBoxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

/** Shared */

export const StyledTagCard = styled.div<{ $isDark: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  gap: 2rem;
  border-radius: ${({ theme }) => theme.radius.small};
  border: solid 1px rgb(212, 216, 223);
  background-color: ${({ theme, $isDark }) => ($isDark ? theme.colors.background.dark : theme.colors.background.light)};
  color: ${({ theme, $isDark }) => ($isDark ? theme.colors.white : theme.colors.black)};
`;

export const StyledTagCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledTagActionIcon = styled.div<{ $isDark: boolean }>`
  cursor: pointer;
  color: ${({ theme, $isDark }) => ($isDark ? theme.colors.grey[400] : theme.colors.grey[700])};
`;

export const StyledEditIcon = styled(StyledTagActionIcon)`
  :hover {
    color: blue;
    opacity: 0.5;
  }
`;

export const StyledSaveIcon = styled(StyledTagActionIcon)`
  :hover {
    color: green;
    opacity: 0.5;
  }
`;

export const StyledDeleteIcon = styled(StyledTagActionIcon)`
  :hover {
    color: red;
  }
`;

export const StyledTag = styled.div<{
  $backgroundColor?: string;
  $fontColor?: string;
  $borderColor?: string;
  $isDisabled?: boolean;
}>`
  background-color: ${({ $backgroundColor, $isDisabled }) => ($isDisabled ? '#F7F9F9' : ($backgroundColor ?? '#b8b2b2'))};
  border: 1px solid ${({ $borderColor, $isDisabled }) => ($isDisabled ? '#E5E7E9' : ($borderColor ?? '#6b6969'))};
  color: ${({ $fontColor, $isDisabled }) => ($isDisabled ? '#566573' : ($fontColor ?? '#4a4949'))};
  border-radius: ${({ theme }) => theme.radius.big};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  width: max-content;
  padding: 0.4rem 0.8rem 0.4rem 0.8rem;
  font-size: 1.6rem;
`;

/** Tagging Modal */

export const StyledModalContents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const StyledFooterWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.8rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
`;

export const StyledTagPreview = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledActionButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1.6rem;
`;

/** Tagging Form */

export const StyledCheckboxInput = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const StyledSearch = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const StyledTagsSelector = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const StyledSelectableTag = styled(StyledTag)<{
  $isSelected: boolean;
  $backgroundColor?: string;
  $fontColor?: string;
  $borderColor?: string;
  $isDisabled?: boolean;
}>`
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'default' : 'pointer')};
  opacity: ${({ $isSelected }) => ($isSelected ? 1 : 0.5)};

  :hover {
    opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 0.75)};
  }
`;

export const StyledTagFormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const StyledCategories = styled.div<{ $wrapFields: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 2rem;

  ${({ $wrapFields }) => $wrapFields && 'flex-wrap: wrap'};

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const StyledSlider = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 1rem;
  font-size: 1.6rem;

  .SliderRoot {
    position: relative;
    display: flex;
    align-items: center;
    user-select: none;
    touch-action: none;
    width: 100%;
    height: 2rem;
  }

  .SliderTrack {
    background-color: ${({ theme }) => theme.colors.background.grey};
    position: relative;
    flex-grow: 1;
    border-radius: 9999px;
    height: 3px;
  }

  .SliderRange {
    position: absolute;
    background-color: ${({ theme }) => theme.colors.background.grey};
    border-radius: 9999px;
    height: 100%;
  }

  .SliderThumb {
    display: flex;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    background-color: ${({ theme }) => theme.colors.background.grey};
    box-shadow: 0 2px 10px var(--black-a7);
    border-radius: 1rem;
  }
  .SliderThumb:hover {
    opacity: 0.5;
  }
  .SliderThumb:focus {
    outline: none;
    box-shadow: 0 0 0 5px var(--black-a8);
  }
`;

export const StyledSliderLabel = styled.div``;
